import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { StaticObjectConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { StaticObjectService } from './api/staticObject.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class StaticObjectApiModule {
    public static forRoot(configurationFactory: () => StaticObjectConfiguration): ModuleWithProviders<StaticObjectApiModule> {
        return {
            ngModule: StaticObjectApiModule,
            providers: [ { provide: StaticObjectConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: StaticObjectApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('StaticObjectApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
